import './PolicyPages.css';

export const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Privacy & Data Policy</h1>
        <p className="last-updated">Last updated: October 30, 2025</p>

        <section>
          <h2>Your Privacy is Important</h2>
          <p>
            SMPP Decoder is a client-side application that prioritizes your privacy. This policy explains how 
            we handle your data and what information we collect (or don't collect).
          </p>
        </section>

        <section>
          <h2>Data Processing - 100% Client-Side</h2>
          <div className="highlight-box">
            <p><strong>Important: All PDU decoding happens in your browser.</strong></p>
            <ul>
              <li>✅ Your PDU data is <strong>never sent to our servers</strong></li>
              <li>✅ All processing is done entirely in your browser</li>
              <li>✅ Your data never leaves your device</li>
              <li>✅ We cannot see, store, or access your PDU content</li>
              <li>✅ Your SMPP messages remain completely private</li>
            </ul>
          </div>
        </section>

        <section>
          <h2>URL Sharing</h2>
          <p>
            When you decode a PDU, it is stored in the URL query parameter (e.g., <code>?pdu=000000E3...</code>). 
            This allows you to:
          </p>
          <ul>
            <li>Share links with colleagues</li>
            <li>Bookmark specific PDUs for later reference</li>
            <li>Refresh the page without losing your work</li>
          </ul>
          <p>
            <strong>Note:</strong> When you share a link, anyone with that link can see the PDU data in the URL. 
            Only share links with trusted parties.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          
          <h3>Automatically Collected Information</h3>
          <ul>
            <li><strong>Basic Analytics:</strong> We may collect anonymous usage statistics through Google Analytics 
            (if implemented), such as page views and general usage patterns</li>
            <li><strong>Advertising Data:</strong> Google AdSense may collect data for serving personalized advertisements</li>
          </ul>

          <h3>Information We Do NOT Collect</h3>
          <ul>
            <li>❌ Your PDU content or SMPP message data</li>
            <li>❌ Personal identifiable information (unless voluntarily provided)</li>
            <li>❌ Login credentials or authentication data</li>
            <li>❌ Any data that could identify specific messages or users</li>
          </ul>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          
          <h3>Google AdSense</h3>
          <p>
            We use Google AdSense to display advertisements. Google may use cookies and similar technologies 
            to serve ads based on your prior visits to our website or other websites. You can opt out of 
            personalized advertising by visiting{' '}
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
              Google Ads Settings
            </a>.
          </p>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            Since all processing happens in your browser and we don't collect or store your PDU data, 
            your information is as secure as your own device. We recommend:
          </p>
          <ul>
            <li>Using HTTPS (our site is served over secure connection)</li>
            <li>Not sharing sensitive PDU links over unsecured channels</li>
            <li>Clearing your browser history if you've decoded sensitive information</li>
          </ul>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>
            Since we don't collect or store your PDU data, there is no personal data for us to delete, 
            modify, or export. You maintain complete control over your data at all times.
          </p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>
            Our service is not directed to children under 13 years of age, and we do not knowingly 
            collect personal information from children.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by 
            posting the new policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us 
            through our website.
          </p>
        </section>

        <div className="back-link">
          <a href="/">← Back to SMPP Decoder</a>
        </div>
      </div>
    </div>
  );
};
